import { Badge, Input, Label } from '@@/ui/primitives';

interface NumberInputProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  min?: number;
  max?: number;
}

export function NumberInput({ value, onChange, disabled = false, label, placeholder, min, max }: NumberInputProps) {
  return (
    <div className='space-y-2'>
      <div className='flex items-center gap-2'>
        {label && <Label className='text-neutral-800 text-sm font-medium'>{label}</Label>}
        <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
          Number
        </Badge>
      </div>
      <Input
        type='number'
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
        placeholder={placeholder}
        className='text-sm! font-medium! bg-white'
        disabled={disabled}
        min={min}
        max={max}
      />
    </div>
  );
}
